const LAST_TEAM_KEY = 'orbitid.lastTeam'
const LAST_ENVIRONMENT_KEY = 'orbitid.lastEnvironment'

export const rememberLastTeam = (slug: string) => {
  try {
    window.localStorage.setItem(LAST_TEAM_KEY, slug)
  } catch {
    return
  }
}

export const readLastTeam = () => {
  try {
    return window.localStorage.getItem(LAST_TEAM_KEY)
  } catch {
    return null
  }
}

export const rememberLastEnvironment = (kind: string) => {
  try {
    window.localStorage.setItem(LAST_ENVIRONMENT_KEY, kind)
  } catch {
    return
  }
}

export const readLastEnvironment = () => {
  try {
    return window.localStorage.getItem(LAST_ENVIRONMENT_KEY)
  } catch {
    return null
  }
}
